// src/components/ScrollToTop.js
import { useEffect, useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  // Use useLayoutEffect to ensure scroll happens before browser paint
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    const handleScroll = () => {
      // Force scroll to top with a slight delay to ensure it works after state updates
      setTimeout(() => {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "instant",
        });
      }, 0);
    };

    // Add event listeners for both popstate and beforeunload
    window.addEventListener("popstate", handleScroll);
    window.addEventListener("beforeunload", handleScroll);

    return () => {
      window.removeEventListener("popstate", handleScroll);
      window.removeEventListener("beforeunload", handleScroll);
    };
  }, []);

  return null;
};

export default ScrollToTop;
